import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig'
import { 
  GET_GENERAL_ORDERS_LIST,
  GET_NEW_ORDERS_LIST,
  GET_CANSHIPP_ORDERS_LIST,
  GET_DRAFT_HOURS_LIST
} from '../queries/GetOrdersList';

const fetchOrdersData = async ({ queryKey }) => {
  const [, { department, plantProdFamilyId, dateColumn, sort, page, dateRange, storedStartDate, storedEndDate, filter, viewAlias, CodeStringFilters, initFilter, productName, token, setToast, visibleColumns }] = queryKey;

  if (!token) throw new Error('Token not available');
  
  try {
    const response = await axios.post(
      `/Orders/pagedFilter/${encodeURIComponent(sort?.[0]?.field || 'isPriority')}`,
      {
        prodFamilyId: department,
        plantProdFamilyId: plantProdFamilyId,
        dateColumn: dateColumn,
        sort: sort?.[0]?.dir || 'des',
        skip: page.skip,
        take: page.take,
        startDate: dateRange.startDate || storedStartDate,
        endDate: dateRange.endDate || storedEndDate,
        filter: JSON.stringify(filter, null, 2),
        viewAlias: viewAlias,
        initFilter: JSON.stringify(initFilter, null, 2),
        CodeStringFilter: JSON.stringify(CodeStringFilters, null, 2),
        productName: productName,
        visibleColumns: visibleColumns
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return {
      totalRows: response.data.totalRows,
      items: response.data.items.map((user, index) => ({
        ...user,
        rowIndex: index + 1 + page.skip,
      })),
    };

  } catch (error) {
    

    if (error.response) {

      setToast({ showToast: true, message: error.response.data, type: 'error' });           
    }
    else {
      setToast({ showToast: true, message: error.message, type: 'error' });
    }
  }
};



export const useGeneralOrdersData = (params) => {
  return useQuery({
    queryKey: [GET_GENERAL_ORDERS_LIST, { ...params, filter: params.debouncedFilter }],
    queryFn: fetchOrdersData,
    enabled: !!params.token, 
    retry: false,
  });
};

export const useNewOrdersData = (params) => {
  return useQuery({
    queryKey: [GET_NEW_ORDERS_LIST, { ...params, filter: params.debouncedFilter }],
    queryFn: fetchOrdersData,
    enabled: !!params.token,
    retry: false,
  });
};

export const useCanShippOrdersData = (params) => {
  return useQuery({
    queryKey: [GET_CANSHIPP_ORDERS_LIST, { ...params, filter: params.debouncedFilter }],
    queryFn: fetchOrdersData,
    enabled: !!params.token,
    retry: false,
  });
};

export const useDraftHoursData = (params) => {
  return useQuery({
    queryKey: [GET_DRAFT_HOURS_LIST, { ...params, filter: params.debouncedFilter }],
    queryFn: fetchOrdersData,
    enabled: !!params.token,
    retry: false,
  });
};